(function () {
  Flint.file('mframework/views/optionsPicker.js', function (require) {
    /*
      props:
        options: [
          {label, value}
        ]
    */

    Flint.staticStyles('OptionsPicker', {
      '$': '#_flintapp .ViewOptionsPicker'
    }, {
      '$': {
        flexDirection: 'row',
        flexWrap: 'wrap'
      }
    });
    Flint.view('OptionsPicker', function (view, on, $) {
      var pro = initPro(view, {
        innerStyle: M.mapAtom({}),
        options: M.listAtom(),
        initialValues: M.listAtom([]),
        limit: M.defaultAtom(null),
        values: M.listAtom()
      });

      var selectedValues = atom(pro.initialValues.get());

      pro.values.react(function (propValues) {
        selectedValues.set(propValues);
      }, { when: function when() {
          return pro.values.get() != null;
        } });

      var onChange = function onChange(value, selected) {
        var nextSelectedValues = selectedValues.get();

        var index = selectedValues.get().indexOf(value);
        if (selected) {
          if (index == -1) {
            if (pro.limit.get() == null || selectedValues.get().size < pro.limit.get()) {
              nextSelectedValues = selectedValues.get().push(value).sort(M.util.compare);
            } else if (pro.limit.get() == 1) {
              nextSelectedValues = List([value]);
            }
          }
        } else {
          if (index >= 0) {
            nextSelectedValues = selectedValues.get().splice(index, 1);
          }
        }

        if (pro.values.get() == null) {
          selectedValues.set(nextSelectedValues);
        }

        if (view.props.onChange) {
          view.props.onChange({ selectedValues: nextSelectedValues });
        }
      };

      var hoveringIndex = atom(-1);view.render(function () {
        return Flint.range(pro.options.get()).map(function (_, _index) {
          return view.el(
            ['FilterOption', 1, _, _index],
            { repeat: pro.options.get(),
              selected: selectedValues.get().indexOf(_.value) >= 0,
              onChange: function (e) {
                return onChange(_.value, e.selected);
              },
              onHover: function (e) {
                return hoveringIndex.set(e.hovering ? _index : -1);
              },
              innerStyle: IMap({
                padding: [4, 8],
                margin: 4
              }).merge(pro.innerStyle.get()).merge(selectedValues.get().size ? null : hoveringIndex.get() == _index ? null : { background: '#fff' }).toJS()
            },
            _.label
          );
        });
      });
    });
  })
})();
//# sourceMappingURL=optionsPicker.js.map
